import React, { useEffect, useState } from "react";
import { withAuthenticationControllerWrapper } from "../AuthenticationControllerWrapper";
import { Link } from "react-router-dom";
import { SignUpValidation } from "../../../utils/helpers/helperMethods/FormValidation";
import InputController from "../../../components/atoms/InputController/General/TextField-input/InputController";
import LogoIconFullColor from "../../../styles/icons/IconFiles/CommonIcons/LogoIconFullColor";
import { useMsal } from "@azure/msal-react";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import PreLoginMenu from "./preLoginMenu";
import {
  validatePhoneNumber,
  cleanPhoneNumberInput,
} from "../../../utils/validationUtils";

const SignUp = ({ ...hocProps }) => {
  const { loginRequest } = UseAuthConfig();
  const [inputValue, setInputValue] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    jobTitle: "",
    companyName: "",
    mobileNumber: "",
    type: 2,
    requestStatus: 1,
    userNote: "",
    requestNote: "",
  });
  const { email, firstName, lastName, jobTitle, companyName, mobileNumber } =
    inputValue;
  const [inputErrorValue, setInputErrorValue] = React.useState({
    email: { error: true, message: "Add Your Email Address" },
    firstName: { error: true, message: "Add Your First Name" },
    lastName: { error: true, message: "Add Your Last Name" },
    jobTitle: { error: true, message: "Add Your Job Title" },
    companyName: { error: true, message: "Add Your Company Name" },
    mobileNumber: { error: true, message: "Add Your Mobile Number" },
  });
  const [clickSubmit, setClickSubmit] = React.useState(false);
  const { instance } = useMsal();
  const handleChange = (e: any) => {
    let { name, value } = e.target;
    if (name === "mobileNumber") {
      const cleanedValue = cleanPhoneNumberInput(value);

      setInputValue((prev) => ({
        ...prev,
        mobileNumber: cleanedValue,
      }));
      return;
    }
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setClickSubmit(true);
    if (
      !(
        inputErrorValue.email.error ||
        inputErrorValue.firstName.error ||
        inputErrorValue.lastName.error ||
        inputErrorValue.jobTitle.error ||
        inputErrorValue.companyName.error ||
        inputErrorValue.mobileNumber.error
      )
    ) {
      hocProps.handleSignUp(inputValue);
    }
  };

  useEffect(() => {
    SignUpValidation(inputValue, inputErrorValue, setInputErrorValue);
    const phoneValidation = validatePhoneNumber(inputValue.mobileNumber);
    setInputErrorValue((prev) => ({
      ...prev,
      mobileNumber: {
        error: !phoneValidation.isValid,
        message: phoneValidation.message || "Add Your Mobile Number",
      },
    }));
  }, [inputValue]);

  const handleDisable = () => {
    return false;
  };

  const handleLoginRedirect = async () => {
    setIsLoading(true);
    try {
      instance.loginRedirect(loginRequest).then((res) => res);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="authentication-page">
      <div className="header-section">
        <Link to="/">
          <LogoIconFullColor />
        </Link>

        <div className="right-menu">
          <PreLoginMenu handleLoginRedirect={handleLoginRedirect} />
        </div>
      </div>
      <div className="sign-up-section box-container">
        <form onSubmit={handleSubmit}>
          <h1 className="heading">
            Sign up <span>erniee.ai</span>
          </h1>
          <label htmlFor="">Enter email address</label>
          <div className="input-row">
            <InputController
              value={email}
              name="email"
              placeholder="Email"
              type={"email"}
              onChange={(e) => handleChange(e)}
              label={null}
              errors={inputErrorValue.email}
              clickSubmit={clickSubmit}
            />
          </div>

          <div className="double-input-row">
            <div className="section">
              <label htmlFor="">First Name</label>
              <div className="input-row-half" style={{ marginRight: "10px" }}>
                <InputController
                  value={firstName}
                  name="firstName"
                  placeholder="Enter first name"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label={null}
                  errors={inputErrorValue.firstName}
                  clickSubmit={clickSubmit}
                />
              </div>
            </div>
            <div className="section">
              <label htmlFor="">Surname</label>
              <div className="input-row-half">
                <InputController
                  value={lastName}
                  name="lastName"
                  placeholder="Enter surname"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label={null}
                  errors={inputErrorValue.lastName}
                  clickSubmit={clickSubmit}
                />
              </div>
            </div>
          </div>

          <label htmlFor="">Job Title</label>
          <div className="input-row">
            <InputController
              value={jobTitle}
              name="jobTitle"
              placeholder="Enter your job title"
              type={"text"}
              onChange={(e) => handleChange(e)}
              label={null}
              errors={inputErrorValue.jobTitle}
              clickSubmit={clickSubmit}
            />
          </div>

          <label htmlFor="">Company Name</label>
          <div className="input-row">
            <InputController
              value={companyName}
              name="companyName"
              placeholder="Enter your company name"
              type={"text"}
              onChange={(e) => handleChange(e)}
              label={null}
              errors={inputErrorValue.companyName}
              clickSubmit={clickSubmit}
            />
          </div>

          <label htmlFor="">Mobile Number</label>
          <div className="input-row">
            <InputController
              value={mobileNumber}
              name="mobileNumber"
              placeholder="+61 4XX XXX XXX"
              type="tel"
              inputMode="tel"
              onChange={(e) => handleChange(e)}
              label={null}
              errors={inputErrorValue.mobileNumber}
              clickSubmit={clickSubmit}
            />
          </div>
          <button className="btn" disabled={handleDisable()}>
            Sign up
          </button>
        </form>
      </div>
    </div>
  );
};

export default withAuthenticationControllerWrapper(SignUp);
